import { Component, ViewChild, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MasterService } from '../../master.service';
import { BillingMilestoneDialogComponent } from '../billing-milestone-dialog/billing-milestone-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationMessageComponent, ConfirmationDialog } from '../../../comman-components/confirmation-message/confirmation-message.component';

@Component({
  selector: 'app-billing-milestone-list',
  templateUrl: './billing-milestone-list.component.html',
  styleUrls: ['./billing-milestone-list.component.scss']
})
export class BillingMilestoneListComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public displayedColumns = ['position', 'action', 'woTypeName', 'milestoneDescription', 'status'];
  dataSource = new MatTableDataSource<any>();
  totalData: any;

  constructor(private masterService: MasterService, public dialog: MatDialog, private snackBar: MatSnackBar) {}

  ngOnInit(): void {
    this.getAllBillingMilestones(0);
  }

  getAllBillingMilestones(page) {
    this.masterService.getBillingMilestonesByPageCount({ page: page }).subscribe(res => {
      this.dataSource.data = res.data;
      this.totalData = res.totalData;
    });
  }

  public createBillingMilestoneDialog(data?: any) {
    let dialogRef = this.dialog.open(BillingMilestoneDialogComponent, {
      panelClass: 'category-dialog-panel',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }

      const payload = {
        billingMilestoneKey: result.billingMilestoneKey || null,
        woType: {
          woTypeKey: result.woTypeKey
        },
        milestoneDescription: result.milestoneDescription,
        status: result.status || 'ACTIVE'
      };

      if (result.billingMilestoneKey) {
        this.masterService.updateBillingMilestone(result.billingMilestoneKey, payload).subscribe(() => {
          this.snackBar.open('Billing Milestone updated successfully', 'Cancel', { duration: 3000, verticalPosition: 'top', panelClass: ['if-success'] });
          this.getAllBillingMilestones(0);
        });
      } else {
        this.masterService.addBillingMilestone(payload).subscribe(() => {
          this.snackBar.open('Billing Milestone created successfully', 'Cancel', { duration: 3000, verticalPosition: 'top', panelClass: ['if-success'] });
          this.getAllBillingMilestones(0);
        });
      }
    });
  }

  toggleBillingMilestoneStatus(element: any) {
    const isCurrentlyActive = element.status === 'ACTIVE';
    const data: ConfirmationDialog = {
      title: 'Billing Milestone Status Confirmation',
      message: isCurrentlyActive ? 'Do you want to Deactivate this Billing Milestone?' : 'Do you want to Activate this Billing Milestone?',
      yes: 'Yes',
      no: 'No'
    };

    const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
      width: '400px',
      height: '200px',
      position: { top: '200px' },
      data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) return;

      const payload = {
        billingMilestoneKey: element.billingMilestoneKey,
        woType: {
          woTypeKey: element.woType?.woTypeKey
        },
        milestoneDescription: element.milestoneDescription,
        status: isCurrentlyActive ? 'INACTIVE' : 'ACTIVE'
      };

      this.masterService.updateBillingMilestone(element.billingMilestoneKey, payload).subscribe(() => {
        element.status = payload.status;
        this.dataSource.data = [...this.dataSource.data];
        this.snackBar.open(
          `Billing Milestone ${payload.status === 'ACTIVE' ? 'Activated' : 'Deactivated'} Successfully`,
          'Cancel',
          { duration: 3000, verticalPosition: 'top', panelClass: ['if-success'] }
        );
      });
    });
  }
}